const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMummySvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 417.6,
    y: 263.923,
    style: {
      fill: "#F9E2A9"
    },
    width: 62.616,
    height: 50.455
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.6,
    y: 263.923,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 62.616,
    height: 50.455
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9E2A9"
    },
    d: "M488.704,437.405c0-39.27-31.835-71.104-71.102-71.104V161.604C417.602,72.354,345.246,0,255.998,0 C166.744,0,94.395,72.354,94.395,161.604v204.697c-39.268,0.004-71.1,31.836-71.1,71.104V512h465.41v-74.595H488.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M417.602,167.884H94.395v16.674h323.206V167.884z M402.124,92.526H109.871 c-2.558,5.4-4.826,10.964-6.783,16.674h305.82C406.953,103.491,404.682,97.927,402.124,92.526z M328.538,17.168H183.454 c-9.362,4.711-18.202,10.305-26.413,16.674h197.912C346.742,27.474,337.902,21.88,328.538,17.168z M417.602,318.599H94.395v16.674 h323.206V318.599z M417.602,243.241H94.395v16.674h323.206V243.241z M121.14,485.988h269.711v-16.674H121.14V485.988z  M407.841,469.314v16.674H488.7v-16.674H407.841z M473.867,393.958H38.132c-3.913,5.061-7.157,10.66-9.605,16.674h454.944 C481.024,404.618,477.78,399.019,473.867,393.958z M23.295,485.988h80.861v-16.674H23.295V485.988z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M170.619,142.794c-15.395,1.546-27.416,14.542-27.416,30.346c0,16.836,13.656,30.495,30.497,30.495 c15.803,0,28.799-12.021,30.343-27.414L170.619,142.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M341.377,142.794c15.395,1.546,27.414,14.542,27.414,30.346c0,16.836-13.654,30.495-30.497,30.495 c-15.803,0-28.797-12.021-30.345-27.414L341.377,142.794z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M389.968,363.763c0-4.87-3.945-8.812-8.81-8.812 c-4.863,0-8.808,3.942-8.808,8.812c0,4.864,3.945,8.807,8.808,8.807C386.023,372.57,389.968,368.625,389.968,363.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M72.535,437.892c0-4.87-3.945-8.81-8.81-8.81 c-4.863,0-8.808,3.941-8.808,8.81c0,4.864,3.945,8.808,8.808,8.808C68.59,446.699,72.535,442.754,72.535,437.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M399.659,275.583c0-4.87-3.945-8.812-8.81-8.812 c-4.861,0-8.808,3.942-8.808,8.812c0,4.864,3.945,8.807,8.808,8.807C395.714,284.39,399.659,280.445,399.659,275.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M362.971,297.963c0-4.871-3.945-8.812-8.81-8.812 c-4.863,0-8.808,3.941-8.808,8.812c0,4.863,3.945,8.807,8.808,8.807C359.025,306.771,362.971,302.824,362.971,297.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M176.861,69.546c0-4.871-3.945-8.813-8.81-8.813 c-4.861,0-8.808,3.942-8.808,8.813c0,4.863,3.945,8.806,8.808,8.806C172.916,78.352,176.861,74.407,176.861,69.546z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M211.72,53.059c0-4.87-3.945-8.812-8.81-8.812 c-4.861,0-8.806,3.942-8.806,8.812c0,4.863,3.943,8.808,8.806,8.808C207.775,61.867,211.72,57.92,211.72,53.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M112.647,453.942c-4.605,0-8.337,3.732-8.337,8.337v49.72h16.674v-49.72 C120.984,457.675,117.252,453.942,112.647,453.942z M399.347,453.942c-4.604,0-8.337,3.732-8.337,8.337v49.72h16.674v-49.72 C407.684,457.675,403.951,453.942,399.347,453.942z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMummySvgrepoCom);
export default __webpack_public_path__ + "static/media/mummy-svgrepo-com.a7e6b732dd6f477cea294bcc37bc073b.svg";
export { ForwardRef as ReactComponent };